import Vue from 'vue';
import CourseService from '@services/course.service';
import KindergartenService from '@services/kindergarten.service';
import {
    SET_COURSE_CHILDREN,
    SET_COURSE_TEACHERS,
    SET_COURSES_SETTINGS,
    ADD_COURSE_TEACHERS,
    REMOVE_COURSE_TEACHER,
    ADD_COURSE_CHILDREN,
    REMOVE_COURSE_CHILD,
    GET_COURSE_CHILDREN,
    GET_COURSE_TEACHERS,
    GET_COURSE_SETTINGS,
    GET_AVAILABLE_CHILDREN,
    SET_AVAILABLE_CHILDREN,
    UPDATE_COURSE_SETTING,
    UPDATE_ALL_COURSE_SETTINGS,
    SET_COURSE_KINDERGARTEN_SETTINGS,
    UPDATE_COURSE_MEALS,
    UPDATE_ALL_COURSE_MEALS,
    UPDATE_COURSE_ABSENCES,
    UPDATE_ALL_COURSE_ABSENCES,
    UPDATE_COURSE_PRESENCES,
    UPDATE_ALL_COURSE_PRESENCES,
    GET_DIARY_SETTINGS,
    SET_DIARY_STATUSES,
    ADD_DIARY_STATUS,
    UPDATE_DIARY_STATUS,
    GET_AVAILABLE_SUMMER_CHILDREN,
    UPDATE_COURSE_CHILD,
    UPDATE_COURSE_TEACHER,
    GET_DIARY_FEEDBACK_TYPES,
    SET_DIARY_FEEDBACK_TYPES,
    STORE_DIARY_FEEDBACK_TYPE,
    ADD_DIARY_FEEDBACK_TYPE,
    UPDATE_DIARY_FEEDBACK_TYPE,
    SET_DIARY_FEEDBACK_TYPE,
    DELETE_DIARY_FEEDBACK_TYPE,
    REMOVE_DIARY_FEEDBACK_TYPE,
    UPDATE_DIARY_LEAVE_TYPE,
    SET_DIARY_LEAVE_TYPE
} from './actions';
import {
    SET_KINDERGARTEN_COURSE_CHILDREN_COUNT,
    SET_KINDERGARTEN_COURSE_TEACHERS
} from '@/store/modules/kindergarten/actions';

const getDefaultState = () => {
    return {
        courseChildren: [],
        courseTeachers: [],
        //opened course settings
        available_children: [],
        settings: [],
        general_settings: [],
        statuses: [],
        message: null,
        feedback_types: [],
        leave_type: null
    };
};

const state = getDefaultState();

const mutations = {
    [SET_COURSE_TEACHERS](state, data) {
      state.courseTeachers = data;
    },
    [SET_COURSE_CHILDREN](state, data) {
        state.courseChildren = data;
    },
    [SET_COURSES_SETTINGS](state, data) {
        data.forEach(course => {
            course.absent_statuses.sort((a, b) => a.pivot.order - b.pivot.order);
            course.present_statuses.sort((a, b) => a.pivot.order - b.pivot.order);
        });
        state.settings = data;
    },
    [UPDATE_COURSE_SETTING](state, data) {
        const index = state.settings.findIndex(course => course.id === data.id);
        if (index !== -1) {
            data.absent_statuses.sort((a, b) => a.pivot.order - b.pivot.order);
            data.present_statuses.sort((a, b) => a.pivot.order - b.pivot.order);
            Vue.set(state.settings, index, data);
        }
    },
    [SET_AVAILABLE_CHILDREN](state, children) {
        state.available_children = children;
    },
    [SET_COURSE_KINDERGARTEN_SETTINGS](state, settings) {
        state.general_settings = settings;
    },
    [SET_DIARY_STATUSES](state, statuses) {
        state.statuses = statuses;
    },
    [ADD_DIARY_STATUS](state, status) {
        state.statuses.push(status);
    },
    [UPDATE_DIARY_STATUS](state, data) {
        const index = state.statuses.findIndex(status => status.id === data.id);
        if (index !== -1) {
            Vue.set(state.statuses, index, data);
        }
    },
    [SET_DIARY_FEEDBACK_TYPES] (state, data) {
        state.feedback_types = data;
    },
    [ADD_DIARY_FEEDBACK_TYPE](state, data) {
        state.feedback_types.push(data);
    },
    [SET_DIARY_FEEDBACK_TYPE](state, data) {
        const index = state.feedback_types.findIndex(status => status.id === data.id);
        if (index !== -1) {
            Vue.set(state.feedback_types, index, data);
        }
    },
    [REMOVE_DIARY_FEEDBACK_TYPE](state, id) {
        state.feedback_types = state.feedback_types.filter(m => m.id !== id);
    },
    [SET_DIARY_LEAVE_TYPE](state, data) {
        state.leave_type = data;
    }
};

const actions = {
    [ADD_COURSE_CHILDREN]({ commit, getters }, data) {
        return CourseService.addChildren(getters.activeKindergartenId, data.id, {
            children: data.children
        }).then(res => {
            commit(SET_COURSE_CHILDREN, res.children);
            commit(SET_KINDERGARTEN_COURSE_CHILDREN_COUNT, {courseId: data.id, counts: res});
        });
    },
    [UPDATE_COURSE_CHILD]({commit, getters}, data) {
      return CourseService.updateChild(getters.activeKindergartenId, data.courseId, data).then(res => {
          commit(SET_COURSE_CHILDREN, res.children);
          commit(SET_KINDERGARTEN_COURSE_CHILDREN_COUNT, {courseId: data.courseId, counts: res});
      });
    },
    [REMOVE_COURSE_CHILD]({ commit, getters }, data) {
        return CourseService.removeChild(getters.activeKindergartenId, data.courseId, data.courseChildId).then(res => {
            commit(SET_COURSE_CHILDREN, res.children);
            commit(SET_KINDERGARTEN_COURSE_CHILDREN_COUNT, {courseId: data.courseId, counts: res});
        });
    },
    [ADD_COURSE_TEACHERS]({ commit, getters }, data) {
        return CourseService.addTeachers(getters.activeKindergartenId, data.id, {teachers: data.teachers})
            .then(res => {
                commit(SET_COURSE_TEACHERS, res.teachers);
                commit(SET_KINDERGARTEN_COURSE_TEACHERS, {courseId: data.id, teachers: res.current_teachers});
            });
    },
    [UPDATE_COURSE_TEACHER]({commit, getters}, data) {
        return CourseService.updateTeacher(getters.activeKindergartenId, data.courseId, data).then(res => {
            commit(SET_COURSE_TEACHERS, res.teachers);
            commit(SET_KINDERGARTEN_COURSE_TEACHERS, {courseId: data.courseId, teachers: res.current_teachers});
        });
    },
    [REMOVE_COURSE_TEACHER]({ commit, getters }, data) {
        return CourseService.removeTeacher(getters.activeKindergartenId, data.courseId, data.course_teacher_id).then(res => {
            commit(SET_COURSE_TEACHERS, res.teachers);
            commit(SET_KINDERGARTEN_COURSE_TEACHERS, {courseId: data.courseId, teachers: res.current_teachers});
        });
    },
    [GET_COURSE_CHILDREN]({commit, getters}, courseId) {
        commit(SET_COURSE_CHILDREN, []);
        return CourseService.getCourseChildren(getters.activeKindergartenId, courseId).then(res => {
            commit(SET_COURSE_CHILDREN, res);
            return res;
        });
    },
    [GET_COURSE_TEACHERS]({commit, getters}, courseId) {
        commit(SET_COURSE_TEACHERS, []);
        return CourseService.getCourseTeachers(getters.activeKindergartenId, courseId).then(res => {
            commit(SET_COURSE_TEACHERS, res);
        });
    },
    [GET_COURSE_SETTINGS]({commit, getters}, type) {
        return CourseService.getCourseSettings(getters.activeKindergartenId, type).then(res => {
            commit(SET_COURSES_SETTINGS, res.courses);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_COURSE_SETTING]({commit, getters}, {courseId, form}) {
        return CourseService.updateCourseSetting(getters.activeKindergartenId, courseId, form).then(res => {
            commit(UPDATE_COURSE_SETTING, res.course);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_ALL_COURSE_SETTINGS]({commit, getters}, data) {
        return CourseService.updateAllCourseSettings(getters.activeKindergartenId, data).then(res => {
            commit(SET_COURSES_SETTINGS, res.courses);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_COURSE_MEALS]({commit, getters}, {courseId, meals}) {
        return CourseService.updateCourseMeals(getters.activeKindergartenId, courseId, meals).then(res => {
            commit(UPDATE_COURSE_SETTING, res);
        });
    },
    [UPDATE_ALL_COURSE_MEALS]({commit, getters}, data) {
        return CourseService.updateAllCourseMeals(getters.activeKindergartenId, data).then(res => {
            commit(SET_COURSES_SETTINGS, res);
        });
    },
    [UPDATE_COURSE_ABSENCES]({commit, getters}, {courseId, absences}) {
        return CourseService.updateCourseAbsentStatuses(getters.activeKindergartenId, courseId, absences).then(res => {
            commit(UPDATE_COURSE_SETTING, res.course);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_ALL_COURSE_ABSENCES]({commit, getters}, data) {
        return CourseService.updateAllCoursesAbsentStatuses(getters.activeKindergartenId, data).then(res => {
            commit(SET_COURSES_SETTINGS, res.courses);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_COURSE_PRESENCES]({commit, getters}, {courseId, statuses}) {
        return CourseService.updateCoursePresentStatuses(getters.activeKindergartenId, courseId, statuses).then(res => {
            commit(UPDATE_COURSE_SETTING, res.course);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [UPDATE_ALL_COURSE_PRESENCES]({commit, getters}, data) {
        return CourseService.updateAllCoursesPresentStatuses(getters.activeKindergartenId, data).then(res => {
            commit(SET_COURSES_SETTINGS, res.courses);
            commit(SET_COURSE_KINDERGARTEN_SETTINGS, res.settings);
        });
    },
    [GET_AVAILABLE_CHILDREN]({commit, getters}, request) {
        commit(SET_AVAILABLE_CHILDREN, []);
        return CourseService.getCourselessChildren(getters.activeKindergartenId, request).then(res => {
            commit(SET_AVAILABLE_CHILDREN, res);
        });
    },
    [GET_AVAILABLE_SUMMER_CHILDREN]({commit, getters}, request) {
        commit(SET_AVAILABLE_CHILDREN, []);
        return CourseService.getCourselessSummerChildren(getters.activeKindergartenId, request).then(res => {
            commit(SET_AVAILABLE_CHILDREN, res);
        });
    },
    [GET_DIARY_SETTINGS]({ commit, getters}) {
        // if (getters.diarySettingsStatuses.length) {
        //     return getters.diarySettingsStatuses;
        // }
        return KindergartenService.getDiarySettings(getters.activeKindergartenId).then(res => {
            commit(SET_DIARY_STATUSES, res.statuses);
            commit(SET_DIARY_FEEDBACK_TYPES, res.feedbackTypes);
            commit(SET_DIARY_LEAVE_TYPE, res.leaveType);
        });
    },
    [ADD_DIARY_STATUS]({ commit, getters}, status) {
        return KindergartenService.insertDiaryStatus(getters.activeKindergartenId, status).then(res => {
            commit(ADD_DIARY_STATUS, res);
        });
    },
    [UPDATE_DIARY_STATUS]({ commit, getters}, status) {
        return KindergartenService.updateDiaryStatus(getters.activeKindergartenId, status).then(res => {
            commit(UPDATE_DIARY_STATUS, res);
        });
    },
    [GET_DIARY_FEEDBACK_TYPES]({commit ,getters}) {
        return KindergartenService.getDiaryFeedbackTypes(getters.activeKindergartenId).then(res => {
            commit(SET_DIARY_FEEDBACK_TYPES, res);
        });
    },
    [STORE_DIARY_FEEDBACK_TYPE]({commit, getters}, feedback) {
        return KindergartenService.insertDiaryFeedbackType(getters.activeKindergartenId, feedback).then(res => {
            commit(ADD_DIARY_FEEDBACK_TYPE, res);
        });
    },
    [UPDATE_DIARY_FEEDBACK_TYPE]({commit, getters}, feedback) {
        return KindergartenService.updateDiaryFeedbackType(getters.activeKindergartenId, feedback).then(res => {
            commit(SET_DIARY_FEEDBACK_TYPE, res);
        });
    },
    [DELETE_DIARY_FEEDBACK_TYPE]({commit ,getters}, id) {
        return KindergartenService.deleteDiaryFeedbackType(getters.activeKindergartenId, id).then(() => {
            commit(REMOVE_DIARY_FEEDBACK_TYPE, id);
        });
    },
    [UPDATE_DIARY_LEAVE_TYPE]({commit, getters}, data) {
        return KindergartenService.updateDiaryLeaveType(getters.activeKindergartenId, data).then(res => {
            commit(SET_DIARY_LEAVE_TYPE, res);
        });
    }
};

const getters = {
    availableChildren: state => state.available_children,
    courseSettings: state => state.settings,
    kindergartenDiarySettings: state => state.general_settings,
    kindergartenDiaryFeedbackTypes: state => state.feedback_types,
    kindergartenDiaryLeaveType: state => state.leave_type,
    diarySettingsStatuses: state => state.statuses,
    coursePeriodUpdateMessage: state => state.message,
    courseChildren: state => state.courseChildren,
    courseTeachers: state => state.courseTeachers
};

export default {
    state,
    mutations,
    actions,
    getters
};
